<template>
    <div class="main-container">
        <bread-crumb v-bind="{ breadcrumbPath: breadcrumbPath }" />
        <v-card
            class="mx-auto text-center mb-3"
            max-width="350"
            min-width="350"
        >
            <v-card-title>
                <h3 style="display: block; margin: auto">
                    Error 404
                </h3>
            </v-card-title>
            <v-card-text class="mb-3">
                <i class="mx-auto fas fa-exclamation" />
                <p>
                    Page Not Found
                </p>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import BreadCrumb from '@/components/BreadCrumb.vue';

    export default {
        name: "Home",
        components: {
            BreadCrumb,
        },
        data() {
            return {
                breadcrumbPath: ['Not Found'],
            };
        },
    }

</script>

<style scoped>

</style>
